import '../../styles/templates/page.help.pcss';

import {Toggle} from '../ui/toggle';

const accountNavToggle = document.querySelector(
  '[data-help-nav-toggle]'
);

if (accountNavToggle) {
  new Toggle(accountNavToggle);
}
